export const BRAND_DISCLAIMER =
  'This size chart is brand specific. Please note that sizes vary from manufacturer to manufacturer. If you are not sure about your size, AMX Superstores will be happy to offer general advice on sizing.';
export const GENERIC_DISCLAIMER =
  'This size chart is not brand specific. Please note that sizes vary from manufacturer to manufacturer. If you are not sure about your size, AMX Superstores will be happy to offer general advice on sizing.';
export const REFUNDS_TITLE = '30 Day returns and exchanges';
export const REFUNDS_BLURB =
  'If your gear doesn’t quite fit, you can return or exchange it within 30 days.';
